export const SET_NOTIFICATION = 'setNotification';
export const REMOVE_NOTIFICATION = 'removeNotification';